/* ============================================================================
   HELLOSLIM TANK (ATLET) — hs27 davranış scripti (yaprak site)
   Landing script.js + enhance.js'in Shopify'a uyarlanmış hali.
   ÇIKARILDI: kendi navbar/mobil menü/footer/legal modal/stoktv iframe formu.
   EKLENDİ  : Shopify sepet + paket modalı.
   Veriler: window.HS27 (section schema'dan gelir)
   ============================================================================ */
(function () {
  'use strict';

  var CFG = window.HS27 || {};
  var root = document.querySelector('.hs27');
  if (!root) return;

  /* ---------------- scroll reveal ---------------- */
  function reveal() {
    var items = root.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- SSS ---------------- */
  function faq() {
    root.querySelectorAll('.faq-list details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        root.querySelectorAll('.faq-list details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------------- yumuşak kaydırma (tema başlığı için pay) ---------------- */
  function smooth() {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var t = root.querySelector(href);
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------------- sabit alt bar + WhatsApp ---------------- */
  function floats() {
    var bar = root.querySelector('.floating-order');
    var wa = root.querySelector('.wa-float');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (bar) bar.classList.toggle('show', y > 620);
      if (wa) wa.classList.toggle('show', y > 600);
    }, { passive: true });
  }

  /* ---------------- paket seçimi ---------------- */
  var selected = null;

  var selPaket = null, selBeden = null, curAdet = 6, curPrice = '', curQty = '1', curGift = 0, nudged = false;

  function fmtVariants() { return (CFG.variants || []); }

  function resolve() {
    var vs = fmtVariants();
    var match = null;
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].paket === selPaket && (selBeden === null || vs[i].beden === selBeden)) {
        if (selBeden !== null) { match = vs[i]; break; }
      }
    }
    var hid = root.querySelector('#hs27VariantId');
    if (hid && match) hid.value = match.id;
    root.querySelectorAll('.hs27-buy').forEach(function (go) {
      if (match && match.available) {
        go.disabled = false; go.classList.remove('need-beden');
        go.innerHTML = '<b>✓ SİPARİŞİ TAMAMLA — KAPIDA ÖDE</b><small>' + (selPaket || (curAdet + ' Adet')) + ' · ' + (match.priceStr || curPrice) + ' · Kargo bedava</small>';
      } else if (selPaket && selBeden) {
        go.disabled = true; go.classList.remove('need-beden');
        go.innerHTML = '<b>BU BEDEN TÜKENDİ</b><small>Başka bir beden seçebilirsin</small>';
      } else {
        /* beden seçilmedi: buton yine SİPARİŞ butonu gibi görünür, tıklayınca beden alanına götürür */
        go.disabled = false; go.classList.add('need-beden');
        go.innerHTML = '<b>🛒 KAPIDA ÖDEMELİ SİPARİŞ VER</b><small>👆 Bedenini seç — 10 saniyede tamamla</small>';
      }
    });
    root.querySelectorAll('[data-bd-hint]').forEach(function (e) {
      e.textContent = selBeden ? '· ' + selBeden + ' seçildi' : '· lütfen seçin';
    });
  }

  function pickPaket(card) {
    if (!card) return;
    selPaket = card.getAttribute('data-paket');
    root.querySelectorAll('.pkg-card, .tk-chip').forEach(function (c) {
      c.classList.toggle('sel', c.getAttribute('data-paket') === selPaket);
    });
    /* seçim mikroanimasyonu */
    card.classList.remove('pop'); void card.offsetWidth; card.classList.add('pop');
    setTimeout(function () { card.classList.remove('pop'); }, 500);
    root.querySelectorAll('.pkg-save').forEach(function (sv) {
      sv.classList.remove('save-flash'); void sv.offsetWidth; sv.classList.add('save-flash');
      setTimeout(function () { sv.classList.remove('save-flash'); }, 900);
    });
    var price = card.getAttribute('data-price');
    var unit = card.getAttribute('data-unit');
    curGift = parseInt(card.getAttribute('data-gift') || '0', 10) || 0;
    var qty = card.getAttribute('data-qty');
    var adet = card.getAttribute('data-adet') || (Number(qty) * 6);
    var save = card.getAttribute('data-save');
    var comp = card.getAttribute('data-compare');
    curAdet = adet; curPrice = price; curQty = qty;
    root.querySelectorAll('[data-pkg-total],[data-price-now],[data-hero-price]').forEach(function (e) {
      if (e.textContent !== price) {
        e.textContent = price;
        e.classList.add('price-flash');
        setTimeout(function () { e.classList.remove('price-flash'); }, 450);
      }
    });
    root.querySelectorAll('[data-hero-adet]').forEach(function (e) { e.textContent = adet + ' ADET'; });
    root.querySelectorAll('[data-hero-adet2]').forEach(function (e) { e.textContent = adet + ' Adet'; });
    root.querySelectorAll('[data-total-old]').forEach(function (e) {
      if (comp) { e.textContent = comp; e.hidden = false; } else { e.textContent = ''; e.hidden = true; }
    });
    /* indirim yüzdesi pilleri */
    var indPct = 0;
    try {
      var pn = parseInt(String(price).replace(/[^0-9]/g, ''), 10);
      var cn = parseInt(String(comp || '').replace(/[^0-9]/g, ''), 10);
      if (cn > pn) indPct = Math.round(100 - pn * 100 / cn);
    } catch (e) {}
    root.querySelectorAll('[data-ind-pill]').forEach(function (e) {
      if (indPct > 0) { e.textContent = '-%' + indPct; e.hidden = false; } else { e.hidden = true; }
    });
    root.querySelectorAll('[data-hero-gift]').forEach(function (e) {
      if (curGift > 0) { e.textContent = '🎁 +' + curGift + ' HEDİYE'; e.hidden = false; } else { e.hidden = true; }
    });
    var giftVal = card.getAttribute('data-giftval') || '';
    root.querySelectorAll('[data-hediye-satir]').forEach(function (e) {
      if (curGift > 0) {
        e.hidden = false;
        var a = e.querySelector('[data-hs-adet]'); if (a) a.textContent = curGift;
        var d = e.querySelector('[data-hs-deger]'); if (d && giftVal) d.textContent = giftVal;
      } else { e.hidden = true; }
    });
    root.querySelectorAll('[data-hero-old]').forEach(function (e) {
      if (comp) { e.textContent = comp; e.hidden = false; } else { e.textContent = ''; e.hidden = true; }
    });
    root.querySelectorAll('.ho-ship').forEach(function (e) { e.textContent = '🚚 Kargo bedava'; });
    root.querySelectorAll('[data-bar-price]').forEach(function (e) { e.textContent = adet + ' Adet · ' + price; });
    root.querySelectorAll('[data-bar-note]').forEach(function (e) {
      e.textContent = (curGift > 0 ? '🎁 ' + curGift + ' adet HEDİYE dahil · ' : '') + 'Kapıda ödeme · Kargo bedava' + (save ? ' · ' + save + ' cepte' : '');
    });
    root.querySelectorAll('[data-price-note]').forEach(function (e) {
      e.innerHTML = adet + ' adet · <b>Kargo bedava</b>' + (save ? ' · <b>' + save + ' cebinde kaldı</b>' : '');
    });
    root.querySelectorAll('[data-bar2-adet]').forEach(function (e) { e.textContent = adet + ' Adet'; });
    root.querySelectorAll('[data-bar2-price]').forEach(function (e) { e.textContent = price; });
    root.querySelectorAll('[data-bar2-old]').forEach(function (e) {
      if (comp) { e.textContent = comp; e.hidden = false; } else { e.hidden = true; }
    });
    resolve();
  }

  function pickBeden(btn, sessiz) {
    selBeden = btn.getAttribute('data-beden');
    root.querySelectorAll('.beden-btn').forEach(function (b) {
      b.classList.toggle('sel', b.getAttribute('data-beden') === selBeden);
    });
    resolve();
    /* B: beden hafızası — dönen müşteri tekrar seçmesin */
    try { localStorage.setItem('hs_beden', selBeden); } catch (err) {}
    /* C: beden seçilince satın alma butonuna akış + tek vurgu */
    if (!sessiz) {
      var m = root.querySelector('#hs27Modal');
      if (m && m.classList.contains('open')) {
        var go = m.querySelector('.hs27-buy');
        if (go) {
          try { go.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
          go.classList.remove('buy-vurgu'); void go.offsetWidth; go.classList.add('buy-vurgu');
          setTimeout(function () { go.classList.remove('buy-vurgu'); }, 1400);
        }
      }
    }
  }

  function packages() {
    var cards = root.querySelectorAll('.pkg-card, .tk-chip');
    if (!cards.length) return;
    cards.forEach(function (c) { c.addEventListener('click', function () { pickPaket(c); }); });
    root.querySelectorAll('.beden-btn').forEach(function (b) {
      b.addEventListener('click', function () { pickBeden(b); });
    });
    pickPaket(root.querySelector('.pkg-card.sel') || cards[0]);
  }

  /* ---------------- sipariş modalı (popup) ---------------- */
  function modal() {
    var m = root.querySelector('#hs27Modal');
    if (!m) return;
    function open(e) {
      if (e) e.preventDefault();
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var f = m.querySelector('#hsAd');
        if (f && !f.value) { try { f.focus({ preventScroll: true }); } catch (err) {} }
      }, 260);
    }
    function close() {
      m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* kapanış yakalama: satın almaya gitmiyorsa, oturumda 1 kez */
      if (!window.__hs27Buying) {
        var mc = root.querySelector('[data-mcatch]');
        var mShown = false;
        try { mShown = sessionStorage.getItem('hs27_mcatch_v2') === '1'; } catch (e) {}
        if (mc && !mShown) {
          try { sessionStorage.setItem('hs27_mcatch_v2', '1'); } catch (e) {}
          setTimeout(function () {
            mc.hidden = false;
            void mc.offsetWidth;
            mc.classList.add('open');
          }, 280);
        }
      }
    }
    root.querySelectorAll('.js-order').forEach(function (b) { b.addEventListener('click', open); });
    var mc = root.querySelector('[data-mcatch]');
    if (mc) {
      function mcHide() { mc.classList.remove('open'); setTimeout(function () { mc.hidden = true; }, 350); }
      mc.querySelectorAll('[data-mc-close]').forEach(function (b) { b.addEventListener('click', mcHide); });
      mc.addEventListener('click', function (e) { if (e.target === mc) mcHide(); });
    }
    m.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('open')) close(); });
  }

  /* ============================================================================
     ÖDEME SAYFASINA GEÇ  (ön-dolum YOK)
     Müşteri sadece paket + beden seçer; adres/kişisel bilgileri Shopify'ın
     KENDİ ödeme sayfasında girer ve orada "Siparişi Tamamla"ya basar.
     Shopify checkout altyapısı + Meta pikseli birebir korunur.
       1) sepeti temizle (çift tıkta birikmesin)
       2) NATIVE form POST -> /cart/add + return_to=/checkout
          (submit() olay dinleyicilerini atlar; tema sepet-drawer'ı araya girmez)
     ============================================================================ */
  function checkoutWith(vid, btn) {
    if (!vid) return;
    var addUrl = (CFG.cartAddUrl || '/cart/add');
    var clearUrl = (CFG.cartClearUrl || '/cart/clear') + '.js';
    var old = btn ? btn.innerHTML : '';
    window.__hs27Buying = true;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ödeme sayfasına geçiliyor...'; }

    function go() {
      var f = document.createElement('form');
      f.method = 'post'; f.action = addUrl; f.style.display = 'none';
      var kvs = [['id', String(vid)], ['quantity', '1'], ['return_to', '/checkout']];
      if (CFG.abTest) kvs.push(['properties[_ab]', AB]);
      kvs.forEach(function (kv) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
        f.appendChild(i);
      });
      document.body.appendChild(f);
      HTMLFormElement.prototype.submit.call(f);
    }

    var done = false;
    function once() { if (!done) { done = true; go(); } }
    setTimeout(once, 1200);                       // temizleme takılırsa yine de git
    fetch(clearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(once).catch(once);
    if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = old; }, 8000);
  }

  function guideBeden() {
    var bw = root.querySelector('#hs27Modal .beden-wrap');
    if (!bw) return;
    try { bw.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { bw.scrollIntoView(); }
    bw.classList.remove('bd-flash'); void bw.offsetWidth; bw.classList.add('bd-flash');
    setTimeout(function () { bw.classList.remove('bd-flash'); }, 1600);
  }


  /* A: HIZLI SEÇİM — en çok seçilen paket + beden tek tıkla */
  function hizliSecim() {
    var m = root.querySelector('#hs27Modal'); if (!m) return;
    var wrap = m.querySelector('.pkg-wrap'); if (!wrap || wrap.querySelector('.hizli-secim')) return;
    var mid = m.querySelectorAll('.pkg-card')[1]; if (!mid) return;
    var adet = mid.getAttribute('data-adet');
    var gift = parseInt(mid.getAttribute('data-gift') || '0', 10) || 0;
    var saved = null; try { saved = localStorage.getItem('hs_beden'); } catch (err) {}
    var bed = saved || 'L';
    var hb = document.createElement('button');
    hb.type = 'button'; hb.className = 'hizli-secim';
    hb.innerHTML = '⚡ <b>ÖNERİLEN:</b> ' + (mid.getAttribute('data-paket') || adet + ' Adet') + (gift > 0 ? ' (🎁 ' + gift + ' adedi hediye)' : '') + ' + ' + bed + ' beden' + (saved ? ' <i>· senin bedenin</i>' : '') + '<em>TEK TIKLA SEÇ →</em>';
    wrap.insertBefore(hb, wrap.firstChild);
    hb.addEventListener('click', function () {
      mid.click();
      var bb = m.querySelector('.beden-btn[data-beden="' + bed + '"]');
      if (bb) bb.click();
      hb.classList.add('secildi');
      setTimeout(function () { hb.classList.remove('secildi'); }, 1200);
    });
  }

  /* B: kayıtlı beden varsa otomatik işaretle (sessiz — kaydırma yok) */
  function bedenHafiza() {
    var saved = null; try { saved = localStorage.getItem('hs_beden'); } catch (err) {}
    if (!saved) return;
    if (typeof selBedHint !== 'undefined' && !selBedHint) selBedHint = saved;
    if (!selBeden) {
      var bb = root.querySelector('#hs27Modal .beden-btn[data-beden="' + saved + '"]');
      if (bb) pickBeden(bb, true);
    }
  }

  function buy() {
    root.querySelectorAll('.hs27-buy').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!selBeden) { guideBeden(); return; }
        /* öneri kutusu KAPALI: müşteri tıklayınca doğrudan ödeme sayfasına gider */
        if (false && !nudged && curQty === '1') {
          nudged = true;
          var mid = root.querySelectorAll('#hs27Modal .pkg-card')[1] || root.querySelectorAll('.pkg-card')[1];
          if (mid) {
            var midAdet = mid.getAttribute('data-adet');
            var midPrice = mid.getAttribute('data-price');
            var fark = '';
            try {
              var f = parseInt(midPrice.replace(/[^0-9]/g, ''), 10) - parseInt(curPrice.replace(/[^0-9]/g, ''), 10);
              if (f > 0) fark = '+' + new Intl.NumberFormat('tr-TR').format(f / (midPrice.indexOf(',') > -1 ? 100 : 1)) + ' TL';
            } catch (e) {}
            var ng = document.createElement('div');
            ng.className = 'nudge';
            ng.innerHTML = '<b>' + fark + " fark ile " + midAdet + ' adet olsun mu?</b> Çok daha avantajlı olur.' +
              '<div class="ng-btns"><button type="button" class="ng-evet">Evet, ' + midAdet + ' olsun</button><button type="button" class="ng-hayir">Hayır, böyle iyi</button></div>';
            b.parentNode.insertBefore(ng, b);
            ng.querySelector('.ng-evet').addEventListener('click', function () { mid.click(); ng.remove(); });
            ng.querySelector('.ng-hayir').addEventListener('click', function () {
              ng.remove();
              var h = root.querySelector('#hs27VariantId'); var vid = h && h.value;
              checkoutWith(vid, b);
            });
            return;
          }
        }
        var h = root.querySelector('#hs27VariantId'); var vid = h && h.value;
        checkoutWith(vid, b);
      });
    });
  }

  /* ---------------- geri sayım ---------------- */
  function countdown() {
    var units = root.querySelector('[data-timer-units]');
    var txt = root.querySelector('[data-timer-text]');
    var sub = root.querySelector('[data-timer-subtext]');
    if (!units || !CFG.countdown) return;
    var KEY = 'olbiy_hs27_deadline', W = 864e5, deadline;
    try {
      var st = parseInt(localStorage.getItem(KEY), 10);
      if (!st || st < Date.now()) { st = Date.now() + W; localStorage.setItem(KEY, String(st)); }
      deadline = st;
    } catch (e) { deadline = Date.now() + W; }
    units.hidden = false;
    if (txt) txt.textContent = 'Kampanya bitişine';
    if (sub) sub.textContent = 'Bu avantaj sayaç bitene kadar geçerli';
    var d = units.querySelector('[data-days]'), h = units.querySelector('[data-hours]'),
        m = units.querySelector('[data-minutes]'), s = units.querySelector('[data-seconds]');
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var df = Math.max(0, deadline - Date.now());
      if (d) d.textContent = p(Math.floor(df / 864e5));
      if (h) h.textContent = p(Math.floor(df % 864e5 / 36e5));
      if (m) m.textContent = p(Math.floor(df % 36e5 / 6e4));
      if (s) s.textContent = p(Math.floor(df % 6e4 / 1e3));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- stok çubuğu ---------------- */
  function stock() {
    var cap = Number(CFG.stockTotal), left = Number(CFG.stockLeft);
    var meter = root.querySelector('[data-stock-meter]');
    var txt = root.querySelector('[data-stock-text]');
    var sub = root.querySelector('[data-stock-subtext]');
    if (!meter || !cap || !left || left > cap) return;
    var pct = Math.max(4, Math.round(left / cap * 100));
    requestAnimationFrame(function () { meter.style.width = pct + '%'; });
    if (txt) txt.textContent = left + ' / ' + cap + ' adet kaldı';
    if (sub) sub.textContent = 'Kampanya stoğu sınırlıdır';
  }


  /* hero slayt shovu (6 renk, 2sn) */
  function heroSlider() {
    var wrap = document.getElementById('heroSlider');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.hs-slide');
    var navs = document.querySelectorAll('.hs-nav');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('sel', k === i);
      for (var m = 0; m < navs.length; m++) navs[m].classList.toggle('sel', m === i);
    }
    function play() { timer = setInterval(function () { show(i + 1); }, 2000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    for (var n = 0; n < navs.length; n++) (function (x) {
      navs[x].addEventListener('click', function () { stop(); show(x); play(); });
    })(n);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) play();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : (reduce || play()); });
  }

  /* ---------------- hero thumb galerisi (tasarim katmani 2026) ---------------- */
  function heroThumbs() {
    var main = root.querySelector('#heroMain');
    var thumbs = root.querySelectorAll('.hero-thumbs .ht');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src && main.getAttribute('src') !== src) {
          main.style.opacity = 0;
          setTimeout(function () {
            main.setAttribute('src', src);
            main.style.opacity = 1;
          }, 160);
        }
        thumbs.forEach(function (x) { x.classList.toggle('sel', x === t); });
      });
    });
    main.style.transition = 'opacity .18s ease, transform .6s ease';
  }

  /* ---------------- beden yardimcisi v2: kilo + giyim tercihi ---------------- */
  var selBedHint = null;   /* sihirbazın önerdiği beden (WA mesajına gider) */
  function bedHelper() {
    var wraps = root.querySelectorAll('[data-bed-helper]');
    if (!wraps.length) return;
    var SIRA = ['M', 'L', 'XL', 'XXL'];
    var rows = root.querySelectorAll('.bed-wrap tbody tr');
    function oner(kilo, fit) {
      if (fit !== 'rahat') return kilo;
      var i = SIRA.indexOf(kilo);
      return SIRA[Math.min(i + 1, SIRA.length - 1)];
    }
    wraps.forEach(function (wrap) {
      var res = wrap.querySelector('[data-bed-result]');
      var name = wrap.querySelector('[data-bed-name]');
      var neden = wrap.querySelector('[data-bed-neden]');
      var step2 = wrap.querySelector('[data-bh-step2]');
      var inModal = !!wrap.closest('.modal, #hs27Modal');
      var kiloSec = null, fitSec = null;
      function bitir() {
        var bed = oner(kiloSec, fitSec);
        selBedHint = bed;
        if (name) name.textContent = bed;
        if (neden) neden.textContent = (fitSec === 'rahat' && bed !== kiloSec)
          ? ' — rahat kalıp için bir üst beden önerdik.'
          : ' — kilona ve tercihine göre.';
        if (res) res.hidden = false;
        rows.forEach(function (tr) {
          tr.classList.toggle('bed-hi', (tr.textContent || '').trim().indexOf(bed) === 0);
        });
        /* modal içindeyse: önerilen bedeni otomatik işaretle */
        if (inModal) {
          var btn = root.querySelector('.beden-btn[data-beden="' + bed + '"]');
          if (btn) btn.click();
        }
      }
      wrap.querySelectorAll('.bh-chips:not(.bh-fit) button').forEach(function (b) {
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.bh-chips:not(.bh-fit) button').forEach(function (x) { x.classList.toggle('sel', x === b); });
          kiloSec = b.getAttribute('data-bed');
          if (step2) step2.hidden = false;
          if (fitSec) bitir();
          else if (!step2) { fitSec = 'tam'; bitir(); }
        });
      });
      wrap.querySelectorAll('.bh-fit button').forEach(function (b) {
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.bh-fit button').forEach(function (x) { x.classList.toggle('sel', x === b); });
          fitSec = b.getAttribute('data-fit');
          if (kiloSec) bitir();
        });
      });
    });
  }

  /* ---------------- WhatsApp karsilama balonu (oturumda 1 kez) ---------------- */
  function waTip() {
    var wa = document.querySelector('.wa-float');
    if (!wa) return;
    var shown = false;
    try { shown = sessionStorage.getItem('hs27_watip') === '1'; } catch (e) {}
    if (shown) return;
    var tip = document.createElement('div');
    tip.className = 'wa-tip';
    tip.innerHTML = 'Sorun mu var? Yaz\u0131n \uD83D\uDC4B<button type="button" aria-label="Kapat">\u00D7</button>';
    document.body.appendChild(tip);
    setTimeout(function () { tip.classList.add('show'); }, 6000);
    function hide() { tip.classList.remove('show'); try { sessionStorage.setItem('hs27_watip', '1'); } catch (e) {} }
    tip.querySelector('button').addEventListener('click', hide);
    setTimeout(hide, 16000);
  }

  /* ---------------- kargo vaadi satırı ---------------- */
  function shipCutoff() {
    var els = root.querySelectorAll('[data-ship-cutoff]');
    if (!els.length) return;
    var t = '🚚 ' + (CFG.shipPromise || 'Bugün sipariş ver = yarın kargoda');
    els.forEach(function (e) { e.textContent = t; });
  }

  /* ---------------- kutu açılış sahnesi (görünüme girince otomatik oynar) ---------------- */
  function kutuSahne() {
    var track = root.querySelector('[data-ks-track]');
    if (!track) return;
    var imgs = track.querySelectorAll('.ks-img');
    var cap = track.querySelector('[data-ks-cap]');
    var dots = track.querySelector('[data-ks-dots]');
    if (!imgs.length) return;
    var CAPS = [
      'Kapağı arala — Mercan, Hardal ve Kahve göz kırpıyor…',
      'Kapak açıldı: ilk üç renk özenle katlanmış, hazır.',
      'Ve üç renk daha — Adaçayı, Siyah, Gri. Toplam 6 renk.'
    ];
    function setStage(n) {
      imgs.forEach(function (im) { im.classList.toggle('on', Number(im.dataset.ks) === n); });
      if (cap) cap.textContent = CAPS[n] || CAPS[0];
      if (dots) dots.classList.toggle('fly', n === 2);
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { setStage(2); return; }
    var timer = null;
    function play() {
      if (timer) return;
      var n = 0;
      setStage(0);
      timer = setInterval(function () {
        n++;
        if (n > 2) { clearInterval(timer); timer = null; return; }
        setStage(n);
      }, 1400);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play();
        else stop();
      });
    }, { threshold: 0.35 });
    io.observe(track);
  }

  /* ---------------- haftanın renk takvimi ---------------- */
  function renkTakvim() {
    var strip = root.querySelector('[data-tv-strip]');
    if (!strip) return;
    var img = root.querySelector('[data-tv-img]');
    var cap = root.querySelector('[data-tv-cap]');
    var btns = strip.querySelectorAll('button');
    function pick(b) {
      btns.forEach(function (x) { x.classList.toggle('sel', x === b); });
      if (img && b.dataset.img && img.getAttribute('src') !== b.dataset.img) {
        img.style.opacity = 0;
        setTimeout(function () { img.setAttribute('src', b.dataset.img); img.style.opacity = 1; }, 180);
      }
      if (cap) cap.textContent = b.dataset.cap || '';
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var day = (new Date().getDay() + 6) % 7;
    if (btns[day]) pick(btns[day]);
    if (img) img.style.transition = 'opacity .2s ease';
  }

  /* ---------------- sıradan vs Hello Slim sürgüsü ---------------- */
  function cmpSlider() {
    var frame = root.querySelector('[data-cs-frame]');
    if (!frame) return;
    var top = frame.querySelector('[data-cs-top]');
    var handle = frame.querySelector('[data-cs-handle]');
    var inner = top ? top.querySelector('img') : null;
    if (!top || !handle) return;
    function fit() { if (inner) inner.style.width = frame.getBoundingClientRect().width + 'px'; }
    function setPct(pct) {
      pct = Math.min(96, Math.max(4, pct));
      top.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    function fromEvent(e) {
      var r = frame.getBoundingClientRect();
      var x = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX) - r.left;
      setPct(x / r.width * 100);
    }
    var drag = false;
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      frame.addEventListener(ev, function (e) { drag = true; fromEvent(e); }, { passive: true });
    });
    ['pointermove', 'touchmove'].forEach(function (ev) {
      window.addEventListener(ev, function (e) { if (drag) fromEvent(e); }, { passive: true });
    });
    ['pointerup', 'touchend', 'pointercancel'].forEach(function (ev) {
      window.addEventListener(ev, function () { drag = false; }, { passive: true });
    });
    window.addEventListener('resize', fit, { passive: true });
    fit(); setPct(50);
  }

  /* ---------------- WhatsApp'tan sipariş: hızlı form ---------------- */
  function waNum() { return (window.HS27 && window.HS27.whatsapp) || '905321307934'; }

  function waSend(msg) {
    var url = 'https://wa.me/' + waNum() + '?text=' + encodeURIComponent(msg);
    var w = null;
    try { w = window.open(url, '_blank'); } catch (e) {}
    if (!w) location.href = url;   /* popup engellenirse ayni sekmede ac */
  }

  function waOrder() {
    var btns = root.querySelectorAll('[data-wa-order]');
    if (!btns.length) return;
    var ov = root.querySelector('[data-wa-ov]');

    /* form markup'ı yoksa eski davranış: boş şablonlu mesaj */
    function legacy() {
      waSend('Merhaba 👋 Sipariş vermek istiyorum:\n'
        + '📦 Paket: ' + (selPaket || (curAdet + ' Adet')) + (curGift > 0 ? ' (🎁 ' + curGift + ' adedi hediye)' : '') + ' — ' + curPrice + '\n'
        + '📏 Beden: ' + (selBeden || selBedHint || '') + '\n'
        + '👤 Ad Soyad: \n📞 Telefon: \n📍 Teslimat adresi: \n'
        + '🚚 Kargo: Aras Kargo — ücretsiz\n💵 Ödeme: Kapıda ödeme');
    }

    function openForm() {
      if (!ov) return legacy();
      /* sipariş modalı açıksa önce kapat — form modalın arkasında kalmasın (iOS katman hatası) */
      var om = root.querySelector('#hs27Modal');
      if (om && om.classList.contains('open')) {
        om.classList.remove('open');
        om.setAttribute('aria-hidden', 'true');
      }
      var bed = selBeden || selBedHint;
      ov.querySelectorAll('[data-wf-bed]').forEach(function (b) {
        b.classList.toggle('sel', !!bed && b.getAttribute('data-wf-bed') === bed);
      });
      var oz = ov.querySelector('[data-wa-ozet]');
      if (oz) oz.textContent = '📦 ' + (selPaket || (curAdet + ' Adet')) + (curGift > 0 ? ' (' + curGift + ' adedi HEDİYE)' : '') + ' · ' + curPrice + ' · Kapıda ödeme · Aras Kargo bedava';
      wfPaketIsaretle();
      var saat = ov.querySelector('[data-wa-saat]');
      if (saat) {
        var d = new Date();
        saat.textContent = (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
      }
      var err = ov.querySelector('[data-wf-err]');
      if (err) err.hidden = true;
      ov.hidden = false;
      void ov.offsetWidth;              /* rAF yerine senkron reflow — mobilde garanti */
      ov.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var f = ov.querySelector('input[name="ad"]');
        if (f && !f.value) { try { f.focus({ preventScroll: true }); } catch (e) {} }
      }, 280);
    }

    function closeForm() {
      if (!ov) return;
      ov.classList.remove('open');
      setTimeout(function () { ov.hidden = true; }, 300);
      var om = root.querySelector('#hs27Modal');
      if (!om || !om.classList.contains('open')) document.body.style.overflow = '';
    }

    /* delegasyon: sonradan eklenen/kopyalanan butonlar da calisir */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-wa-order]') : null;
      if (b) { e.preventDefault(); openForm(); }
    });

    /* hediye vitrini biletleri: paketi sec + siparis modalini ac */
    document.addEventListener('click', function (e) {
      var vb = e.target && e.target.closest ? e.target.closest('[data-vitrin-pkt]') : null;
      if (!vb) return;
      var pk = vb.getAttribute('data-paket');
      var card = root.querySelector('.pkg-card[data-paket="' + pk + '"]') || root.querySelector('.tk-chip[data-paket="' + pk + '"]');
      if (card) pickPaket(card);
      var op = root.querySelector('.y-hero .js-order') || root.querySelector('.js-order');
      if (op) op.click();
    });

    if (!ov) return;
    ov.querySelectorAll('[data-wa-close]').forEach(function (b) { b.addEventListener('click', closeForm); });
    ov.addEventListener('click', function (e) { if (e.target === ov) closeForm(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('open')) closeForm(); });

    /* beden çipleri */
    ov.querySelectorAll('[data-wf-bed]').forEach(function (b) {
      b.addEventListener('click', function () {
        ov.querySelectorAll('[data-wf-bed]').forEach(function (x) { x.classList.toggle('sel', x === b); });
        ov.querySelector('[data-wf-beden]').classList.remove('wf-eksik');
        selBedHint = b.getAttribute('data-wf-bed');
        try { localStorage.setItem('hs_beden', selBedHint); } catch (err) {}
      });
    });

    /* adet (paket) çipleri — paket formun üstünden de değiştirilebilsin */
    function wfPaketIsaretle() {
      var chips = ov.querySelectorAll('[data-wf-pkt]');
      if (!chips.length) return;
      var hit = false;
      chips.forEach(function (x) {
        var on = selPaket ? x.getAttribute('data-paket') === selPaket : String(x.getAttribute('data-adet')) === String(curAdet);
        x.classList.toggle('sel', on);
        if (on) hit = true;
      });
      if (!hit) chips[0].classList.add('sel');
    }
    ov.querySelectorAll('[data-wf-pkt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.getAttribute('data-paket');
        var card = root.querySelector('.pkg-card[data-paket="' + p + '"]') || root.querySelector('.tk-chip[data-paket="' + p + '"]');
        if (card) { pickPaket(card); }
        else {
          selPaket = p;
          curAdet = b.getAttribute('data-adet') || curAdet;
          curPrice = b.getAttribute('data-price') || curPrice;
        }
        wfPaketIsaretle();
        var oz2 = ov.querySelector('[data-wa-ozet]');
        if (oz2) oz2.textContent = '📦 ' + (selPaket || (curAdet + ' Adet')) + (curGift > 0 ? ' (' + curGift + ' adedi HEDİYE)' : '') + ' · ' + curPrice + ' · Kapıda ödeme · Aras Kargo bedava';
      });
    });

    var form = ov.querySelector('[data-wa-form]');
    if (!form) return;
    /* telefon maskesi: 05XX XXX XX XX — yalnız rakam, otomatik biçim */
    var telInp = form.querySelector('input[name="tel"]');
    if (telInp) {
      telInp.setAttribute('maxlength', '14');
      telInp.setAttribute('placeholder', '05XX XXX XX XX');
      telInp.addEventListener('input', function () {
        var d = this.value.replace(/\D/g, '');
        if (d.slice(0, 2) === '90') d = d.slice(2);
        if (d.charAt(0) === '0') d = d.slice(1);
        d = d.slice(0, 10);
        var out = '';
        if (d.length) {
          out = '0' + d.slice(0, 3);
          if (d.length > 3) out += ' ' + d.slice(3, 6);
          if (d.length > 6) out += ' ' + d.slice(6, 8);
          if (d.length > 8) out += ' ' + d.slice(8, 10);
        } else if (this.value.indexOf('0') !== -1) { out = '0'; }
        this.value = out;
        this.classList.remove('wf-eksik');
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var g = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      var eksik = false;
      ['ad', 'soyad', 'tel', 'il', 'ilce', 'adres'].forEach(function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        var bos = !el.value.trim();
        el.classList.toggle('wf-eksik', bos);
        if (bos) eksik = true;
      });
      var bedBtn = ov.querySelector('[data-wf-bed].sel');
      var bed = bedBtn ? bedBtn.getAttribute('data-wf-bed') : '';
      ov.querySelector('[data-wf-beden]').classList.toggle('wf-eksik', !bed);
      if (!bed) eksik = true;
      /* telefon dogrulama: 0'dan sonra 5 ile baslayan tam 10 hane */
      var telEl = form.querySelector('[name="tel"]');
      var telD = (telEl ? telEl.value : '').replace(/\D/g, '');
      if (telD.slice(0, 2) === '90') telD = telD.slice(2);
      if (telD.charAt(0) === '0') telD = telD.slice(1);
      var telOk = /^5\d{9}$/.test(telD);
      if (telEl && !telOk) telEl.classList.add('wf-eksik');
      var err = ov.querySelector('[data-wf-err]');
      if (eksik || !telOk) {
        if (err) {
          err.textContent = (!telOk && !eksik)
            ? "Telefon numaranı kontrol et: 0'dan sonra 5 ile başlayan 10 hane olmalı (örn. 0532 123 45 67)."
            : 'Lütfen kırmızı işaretli alanları doldur.';
          err.hidden = false;
        }
        return;
      }
      if (err) { err.hidden = true; err.textContent = 'Lütfen kırmızı işaretli alanları doldur.'; }
      var telFmt = '0' + telD.slice(0, 3) + ' ' + telD.slice(3, 6) + ' ' + telD.slice(6, 8) + ' ' + telD.slice(8, 10);
      var msg = 'Merhaba 👋 Siparişimi tamamlamak istiyorum:\n'
        + '📦 Paket: ' + (selPaket || (curAdet + ' Adet')) + (curGift > 0 ? ' (🎁 ' + curGift + ' adedi hediye)' : '') + ' — ' + curPrice + '\n'
        + '📏 Beden: ' + bed + '\n'
        + '👤 Ad Soyad: ' + g('ad') + ' ' + g('soyad') + '\n'
        + '📞 Telefon: ' + telFmt + '\n'
        + '📍 Adres: ' + g('adres') + ' — ' + g('ilce') + ' / ' + g('il') + '\n'
        + '🚚 Kargo: Aras Kargo — ücretsiz\n'
        + '💵 Ödeme: Kapıda ödeme (teslimatta)';
      waSend(msg);
      closeForm();
    });
  }

  /* ---------------- çıkış yakalama (oturumda 1 kez) ---------------- */
  function exitIntent() {
    var ov = root.querySelector('[data-exit]');
    if (!ov) return;
    var shown = false;
    try { shown = sessionStorage.getItem('hs27_exit_v2') === '1'; } catch (e) {}
    if (shown) return;
    function show() {
      if (shown) return;
      shown = true;
      try { sessionStorage.setItem('hs27_exit_v2', '1'); } catch (e) {}
      ov.hidden = false;
      void ov.offsetWidth;
      ov.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function hide() {
      ov.classList.remove('open');
      document.body.style.overflow = '';
      setTimeout(function () { ov.hidden = true; }, 350);
    }
    ov.querySelectorAll('[data-exit-close]').forEach(function (b) { b.addEventListener('click', hide); });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.classList.contains('eo-bg')) hide(); });
    /* bekçi: sayfada en az 12 sn geçmeden tetiklenmez; modal/yakalama açıkken tetiklenmez */
    var armed = false;
    setTimeout(function () { armed = true; }, 12000);
    function busy() {
      var om = root.querySelector('#hs27Modal');
      var mc = root.querySelector('[data-mcatch]');
      var wf = root.querySelector('[data-wa-ov]');
      return (om && om.classList.contains('open')) || (mc && mc.classList.contains('open')) || (wf && wf.classList.contains('open'));
    }
    document.addEventListener('mouseout', function (e) {
      if (!armed || busy()) return;
      if (!e.relatedTarget && e.clientY < 10 && window.innerWidth > 900) show();
    });
    var lastY = 0, deep = false;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 900) deep = true;
      if (armed && !busy() && deep && lastY - y > 220 && y < 700) show();
      lastY = y;
    }, { passive: true });
  }


  /* ---------------- popup "en avantajlı paket" doldurma + tek tık seçim ---------------- */
  function bestCard() {
    var cards = root.querySelectorAll('.pkg-card');
    for (var i = 0; i < cards.length; i++) { if (cards[i].querySelector('.pkg-flag')) return cards[i]; }
    return cards[1] || cards[0] || null;
  }
  function advFill() {
    var c = bestCard(); if (!c) return;
    var adet = c.getAttribute('data-adet'), price = c.getAttribute('data-price');
    var old = c.getAttribute('data-compare'), save = c.getAttribute('data-save');
    root.querySelectorAll('[data-adv-adet]').forEach(function (e) { e.textContent = adet + ' Adet'; });
    root.querySelectorAll('[data-adv-price]').forEach(function (e) { e.textContent = price; });
    root.querySelectorAll('[data-adv-old]').forEach(function (e) {
      if (old) { e.textContent = old; e.hidden = false; } else { e.hidden = true; }
    });
    root.querySelectorAll('[data-adv-save]').forEach(function (e) { e.textContent = save || price; });
    var g = parseInt(c.getAttribute('data-gift') || '0', 10) || 0;
    var gv = (c.getAttribute('data-giftval') || '').replace(',00', '');
    if (g > 0) {
      root.querySelectorAll('[data-adv-gift]').forEach(function (e) { e.textContent = g + ' adedi HEDİYE'; });
      if (gv) root.querySelectorAll('[data-adv-giftval]').forEach(function (e) { e.textContent = gv; });
    }
  }
  function advCta() {
    root.querySelectorAll('[data-adv-cta]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = bestCard();
        if (c) setTimeout(function () { c.click(); }, 300);
      });
    });
  }

  /* ---------------- ?v= hero varyantları (reklam linkine göre giriş) ---------------- */
  function heroVaryant() {
    var v;
    try { v = new URLSearchParams(location.search).get('v'); } catch (e) { return; }
    var conf = v && CFG.heroVaryantlar && CFG.heroVaryantlar[v];
    if (!conf) return;
    var img = root.querySelector('#heroMain');
    if (img && conf.img) img.src = conf.img;
    var h1 = root.querySelector('.hero-copy h1');
    if (h1 && conf.baslik) h1.innerHTML = conf.baslik;
    var lead = root.querySelector('.hero-lead');
    if (lead && conf.lead) lead.textContent = conf.lead;
  }

  /* ---------------- A/B: fiyat sunumu (sipariş satırında _ab ile ölçülür) ---------------- */
  var AB = 'a';
  function abTest() {
    if (!CFG.abTest) return;
    try {
      AB = localStorage.getItem('hs_ab_v1');
      if (AB !== 'a' && AB !== 'b') { AB = Math.random() < 0.5 ? 'a' : 'b'; localStorage.setItem('hs_ab_v1', AB); }
    } catch (e) { AB = 'a'; }
    if (AB === 'b') document.body.classList.add('ab-b');
  }

  /* ---------------- parmakla renk gezdirme kartı ---------------- */
  function renkSwipe() {
    var wrap = root.querySelector('[data-renk-swipe]');
    if (!wrap) return;
    var stage = wrap.querySelector('[data-rs-stage]');
    var imgs = stage.querySelectorAll('img');
    var label = wrap.querySelector('[data-rs-label]');
    var dotsBox = wrap.querySelector('[data-rs-dots]');
    var RENK_HEX = ['#E8A33D', '#E2593F', '#93A68C', '#B9BCC0', '#6E5445', '#1c1c1c'];
    var cur = 0;
    dotsBox.innerHTML = Array.prototype.map.call(imgs, function (_, i) {
      return '<i style="--rc:' + (RENK_HEX[i] || '#999') + '"' + (i === 0 ? ' class="on"' : '') + '></i>';
    }).join('');
    var dots = dotsBox.querySelectorAll('i');
    function go(i) {
      i = Math.max(0, Math.min(imgs.length - 1, i));
      if (i === cur) return;
      cur = i;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (label) label.textContent = imgs[i].getAttribute('data-renk');
    }
    function fromX(clientX) {
      var r = stage.getBoundingClientRect();
      go(Math.floor(((clientX - r.left) / r.width) * imgs.length));
    }
    stage.addEventListener('pointermove', function (e) { fromX(e.clientX); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { if (e.touches[0]) fromX(e.touches[0].clientX); }, { passive: true });
    stage.addEventListener('click', function () { go((cur + 1) % imgs.length); });
  }

  /* ---------------- canlı sipariş bildirimleri (yalnız panele girilen GERÇEK veriden) ---------------- */
  function liveProof() {
    var raw = (CFG.canliRaw || '').trim();
    var box = root.querySelector('[data-lp-toast]');
    if (!raw || !box) return;
    var items = raw.split(/\r?\n+/).map(function (l) {
      var p = l.split('|');
      return { ad: (p[0] || '').trim(), sehir: (p[1] || '').trim(), adet: parseInt(p[2], 10) || 0 };
    }).filter(function (x) { return x.ad && x.sehir && x.adet; });
    if (!items.length) return;
    items = items.slice().sort(function () { return Math.random() - 0.5; });
    var i = 0, MAXG = 5;
    function show() {
      if (i >= Math.min(items.length, MAXG)) return;
      var it = items[i++];
      var ek = { 6: "'lı", 9: "'lu", 12: "'li" }[it.adet] || "'lı";
      box.innerHTML = '<span class="lp-ico">🛍️</span><span class="lp-txt"><b>' + it.ad + '</b> (' + it.sehir + ') kısa süre önce <b>' + it.adet + ek + ' kutu</b> sipariş etti <i>✓</i></span><button type="button" class="lp-x" aria-label="Kapat">×</button>';
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('show'); });
      box.querySelector('.lp-x').addEventListener('click', hide);
      setTimeout(hide, 6000);
      setTimeout(show, 24000 + Math.random() * 12000);
    }
    function hide() {
      box.classList.remove('show');
      setTimeout(function () { box.hidden = true; }, 350);
    }
    setTimeout(show, 12000);
  }

  /* ---------------- masaüstü sticky üst teklif barı ---------------- */
  function topBar() {
    var bar = root.querySelector('[data-top-bar]');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      bar.classList.toggle('show', window.scrollY > 800 && window.innerWidth > 900);
    }, { passive: true });
  }

  /* ---------------- hero hafif parallax ---------------- */
  function heroParallax() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var img = root.querySelector('.hero-visual img');
    var b1 = root.querySelector('.hs-float-1'), b2 = root.querySelector('.hs-float-2');
    if (!img) return;
    var raf = 0;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 700);
        img.style.transform = 'translateY(' + (y * -0.04) + 'px) scale(1.02)';
        if (b1) b1.style.translate = '0 ' + (y * 0.05) + 'px';
        if (b2) b2.style.translate = '0 ' + (y * 0.03) + 'px';
        raf = 0;
      });
    }, { passive: true });
  }

  function init() { abTest(); heroVaryant(); reveal(); faq(); smooth(); floats(); packages(); modal(); buy(); hizliSecim(); bedenHafiza(); countdown(); stock();  heroSlider(); heroThumbs(); bedHelper(); waTip(); heroParallax(); shipCutoff(); kutuSahne(); renkTakvim(); cmpSlider(); topBar(); waOrder(); exitIntent(); advFill(); advCta(); renkSwipe(); liveProof(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ================= YENİ TASARIM ekleri: renk stüdyosu + önden/arkadan + video ================= */
/* ============================================================
   RENK STÜDYOSU — tekli boxer değiştirici + ambient zemin geçişi
   ============================================================ */
(function () {
  'use strict';

  var st = document.querySelector('[data-studio]');
  if (!st) return;

  var img = st.querySelector('[data-st-img]');
  var ad = st.querySelector('[data-st-ad]');
  var not = st.querySelector('[data-st-not]');
  var amb = st.querySelector('.ys-amb');
  var sahne = st.querySelector('[data-st-sahne]');
  var cips = Array.prototype.slice.call(st.querySelectorAll('[data-st-cips] button'));
  if (!img || !cips.length) return;

  /* görselleri önceden ısıt — geçişler takılmasın */
  cips.forEach(function (b) { var i = new Image(); i.src = b.getAttribute('data-img'); });

  var cur = 0, oto = null, dokundu = false;
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sec(i, kaynak) {
    i = (i + cips.length) % cips.length;
    if (i === cur && kaynak !== 'ilk') return;
    cur = i;
    var b = cips[i];
    cips.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    img.classList.add('gecis');
    setTimeout(function () {
      img.src = b.getAttribute('data-img');
      img.alt = 'Helloslim Tank atlet — ' + b.getAttribute('data-ad');
      img.classList.remove('gecis');
    }, REDUCE ? 0 : 200);
    if (ad) ad.textContent = b.getAttribute('data-ad');
    if (not) not.textContent = b.getAttribute('data-not');
    if (amb) st.style.setProperty('--amb', b.getAttribute('data-hex'));
  }

  cips.forEach(function (b, i) {
    b.addEventListener('click', function () { dokundu = true; durdur(); sec(i, 'tik'); });
  });

  /* sahnede parmak gezdirme (mobil) */
  if (sahne) {
    sahne.addEventListener('touchmove', function (e) {
      if (!e.touches[0]) return;
      dokundu = true; durdur();
      var r = sahne.getBoundingClientRect();
      var i = Math.floor(((e.touches[0].clientX - r.left) / r.width) * cips.length);
      sec(Math.max(0, Math.min(cips.length - 1, i)), 'kaydir');
    }, { passive: true });
    sahne.addEventListener('click', function () { dokundu = true; durdur(); sec(cur + 1, 'tik'); });
  }

  /* kullanıcı dokunana kadar otomatik tur (görünürken) */
  function basla() { if (!oto && !dokundu && !REDUCE) oto = setInterval(function () { sec(cur + 1, 'oto'); }, 3200); }
  function durdur() { if (oto) { clearInterval(oto); oto = null; } }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? basla() : durdur(); });
    }, { threshold: 0.35 }).observe(st);
  }
  document.addEventListener('visibilitychange', function () { document.hidden ? durdur() : null; });

  sec(0, 'ilk');
})();


/* videolar: görünürken oynat, görünmezken duraklat (pil dostu) */
(function () {
  'use strict';
  var vids = document.querySelectorAll('.yv-medya video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { io.observe(v); });
})();


/* önden / arkadan görünüm geçişi */
(function () {
  'use strict';
  var kart = document.querySelector('[data-cift]');
  if (!kart) return;
  var onImg = kart.querySelector('.cift-on');
  var arkaImg = kart.querySelector('.cift-arka');
  var notEl = kart.querySelector('[data-cift-not]');
  kart.querySelectorAll('[data-yon]').forEach(function (b) {
    b.addEventListener('click', function () {
      kart.querySelectorAll('[data-yon]').forEach(function (x) { x.classList.toggle('sel', x === b); });
      var arka = b.getAttribute('data-yon') === 'arka';
      onImg.classList.toggle('sel', !arka);
      arkaImg.classList.toggle('sel', arka);
      if (notEl) notEl.textContent = b.getAttribute('data-not');
    });
  });
})();
